var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickdet01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8282 17.4944V15.8282C15.8282 14.9445 15.4771 14.0969 14.8522 13.472C14.2273 12.847 13.3797 12.496 12.4959 12.496H7.49755C6.61378 12.496 5.7662 12.847 5.14128 13.472C4.51636 14.0969 4.16528 14.9445 4.16528 15.8282V17.4944",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99682 9.16374C11.8372 9.16374 13.3291 7.67183 13.3291 5.83147C13.3291 3.99111 11.8372 2.49921 9.99682 2.49921C8.15646 2.49921 6.66455 3.99111 6.66455 5.83147C6.66455 7.67183 8.15646 9.16374 9.99682 9.16374Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickdet01);
export default __webpack_public_path__ + "static/media/tickdet01.0648e47d2f398cf3ddf9daa284985cef.svg";
export { ForwardRef as ReactComponent };